import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer, useEffect } from 'react';

var WindowSizeReducer = function WindowSizeReducer(state, action) {
  switch (action.type) {
    case 'mobile':
      return Object.assign(Object.assign({}, state), {
        isMobile: action.state
      });

    case 'tabletPortrait':
      return Object.assign(Object.assign({}, state), {
        isTabletPortrait: action.state
      });

    case 'tabletLandscape':
      return Object.assign(Object.assign({}, state), {
        isTabletLandscape: action.state
      });

    case 'desktop':
      return Object.assign(Object.assign({}, state), {
        isDesktop: action.state
      });

    default:
      return state;
  }
};

var getWindowSizeState = function getWindowSizeState() {
  var isMobile = window.innerWidth < 768;
  var isTabletPortrait = window.innerWidth >= 768 && window.innerWidth < 1024;
  var isTabletLandscape = window.innerWidth >= 1024 && window.innerWidth < 1200;
  var isDesktop = window.innerWidth >= 1200;
  return {
    isMobile: isMobile,
    isTabletPortrait: isTabletPortrait,
    isTabletLandscape: isTabletLandscape,
    isDesktop: isDesktop
  };
};

export var useWindowSize = function useWindowSize() {
  var _useReducer = useReducer(WindowSizeReducer, null, getWindowSizeState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var setWindowSizeState = function setWindowSizeState() {
    var _getWindowSizeState = getWindowSizeState(),
        isMobile = _getWindowSizeState.isMobile,
        isTabletPortrait = _getWindowSizeState.isTabletPortrait,
        isTabletLandscape = _getWindowSizeState.isTabletLandscape,
        isDesktop = _getWindowSizeState.isDesktop;

    dispatch({
      type: 'mobile',
      state: isMobile
    });
    dispatch({
      type: 'tabletPortrait',
      state: isTabletPortrait
    });
    dispatch({
      type: 'tabletLandscape',
      state: isTabletLandscape
    });
    dispatch({
      type: 'desktop',
      state: isDesktop
    });
  };

  useEffect(function () {
    window.addEventListener('resize', setWindowSizeState);
    return function () {
      window.removeEventListener('resize', setWindowSizeState);
    };
  }, []);
  return state;
};